// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function panamanianOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'pa',
    document: userInputValues['panamanianDocument'],
    zipcode: userInputValues['panamanianZipcode'],
    state: userInputValues['panamanianState'],
    city: userInputValues['panamanianCity'],
    address: userInputValues['panamanianAddress'],
    street_number: userInputValues['panamanianStreetNumber'],
    street_complement: userInputValues['panamanianStreetComplement'],
    phone_number: userInputValues['panamanianPhoneNumber'],
  };
}
